import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { renderPartials } from 'External';
import { initI18n } from './i18n/i18n'; // ton init i18next

async function bootstrap() {
  // 1️⃣ Initialisation i18n (await pour App)
  await initI18n();

  // 2️⃣ Rendu App React interne
  const root = document.getElementById('root');
  if (root) ReactDOM.render(<App />, root);
}

bootstrap();
renderPartials();
